import { logError, logWarning } from '@/utils/miscUtils';

export interface LeadMetadataPayload {
	leadUpdates: {
		insights: Record<string, string>;
	};
}

export default async function putLeadMetadata(
	url: string,
	payload: LeadMetadataPayload,
	headers: { [key: string]: string } = {}
): Promise<unknown> {
	try {
		const response = await fetch(url, {
			method: 'PUT',
			body: JSON.stringify(payload),
			headers: {
				'Content-Type': 'application/json',
				...headers,
			},
		});

		const data = (await response.json()) as unknown;

		if (response.status === 400) {
			logWarning('putLeadMetadata: 400 validation error');
			return data;
		}

		if (response.ok) {
			return data;
		}

		throw new Error(`Unexpected response status: ${response.status}`);
	} catch (err: unknown) {
		const message = err instanceof Error ? err.message : 'unknown';
		logError(`putLeadMetadata error: ${message}`);
		throw err;
	}
}
